<div class='edit-venue-part'>
	<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>

		<tr>
			<td>Displayed Name</td>
			<td>
				<common-text-field [field]="form.displayedName()"></common-text-field>

			</td>
		</tr>

		<tr>
			<td>Public Notes</td>
			<td>
				<common-text-field [field]="form.publicNotes()"></common-text-field>
			</td>
		</tr>

		<tr>
			<td>Internal Notes</td>
			<td>
				<common-text-field [field]="form.internalNotes()"></common-text-field>
			</td>
		</tr>
	</table>

	<common-button-row [center]="true">
		<button #venueFormSaveBtn class="btn btn-primary">Update</button>
	</common-button-row>
</div>